import { NgModule } from "@angular/core";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { TableComponent } from "./components/table/table.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TabViewModule } from "primeng/tabview";
import { CalendarModule } from "primeng/calendar";
import { PaginationModule } from "ngx-bootstrap";
import { InputSearchBoxComponent } from "./components/input-search-box/input-search-box.component";
import { DetailsCardComponent } from "./components/details-card/details-card.component";
import { DriverLicenceFormComponent } from "./components/driver-licence-form/driver-licence-form.component";
import { DropdownFieldBoxComponent } from "./components/dropdown-field-box/dropdown-field-box.component";
import { FileUploadBoxComponent } from "./components/file-upload-box/file-upload-box.component";
import { InputDateTimeFieldBoxComponent } from "./components/input-date-time-field-box/input-date-time-field-box.component";
import { MapDetailsCardComponent } from "./components/map-details-card/map-details-card.component";
import { PaginationCustomComponent } from "./components/pagination/pagination.component";
import { RegistrationDocsFormComponent } from "./components/registration-docs-form/registration-docs-form.component";
import { ToggleSwitchBoxComponent } from "./components/toggle-switch-box/toggle-switch-box.component";
import { ViewEditUserImageBoxComponent } from "./components/view-edit-user-image-box/view-edit-user-image-box.component";
import { NgbModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { ReactiveFormsModule } from "@angular/forms";
import { SplitButtonModule } from "primeng/splitbutton";
import { SidebarModule } from "primeng/sidebar";
import { FilterBoxComponent } from "./components/filter-box/filter-box.component";
import { TooltipModule } from "primeng/tooltip";
import { MenuModule } from "primeng/menu";
import { DriverService } from "./services/driver/driver.service";
import { AddressDetailsFormComponent } from "./components/address-details-form/address-details-form.component";
import { InputSwitchModule } from "primeng/inputswitch";
import { ContentViewModalComponent } from "./components/content-view-modal/content-view-modal.component";
import { CommonService } from "./services/commen/commen.services";
import { UppercaseNumberPipe } from "./pipe/uppercaseNumber.pipe";
import { NumberFormatPipe } from "./pipe/number-format1.pipe";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { AutoCompleteModule } from "primeng/autocomplete";
import { AccordionModule } from "primeng/accordion";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { MainHeaderComponent } from "./components/main-header/main-header.component";
import { MainFooterComponent } from "./components/main-footer/main-footer.component";
import { NewDefaultPageComponent } from "./components/new-default-page/new-default-page.component";
import { PanelMenuModule } from "primeng/panelmenu";
import { TablePattern1Component } from "./components/table-pattern1/table-pattern1.component";
import { EntityService } from "./services/entity/entity.service";
import { AttachmentListComponent } from "./components/attachment-list/attachment-list.component";
import { MastersService } from "./services/masters/masters.service";
import { EmptyPageComponent } from "./components/empty-page/empty-page.component";
import { ConfirmationPopupComponent } from "./components/confirmation-popup/confirmation-popup.component";
import { ConfirmationPopup_warningComponent } from "./components/confirmation-popup-warning/confirmation-popup-warning.component";
import { ToastComponent } from "./components/toast/toast.component";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { ChartOfAccountsService } from "./services/chartOfAccounts/chartOfAccounts.service";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { MenuListComponent } from "./components/menu-list/menu-list.component";
import { OrdersService } from "./services/orders/orders.service";
import { TripmapComponent } from "./components/tripmap/tripmap.component";
import { SharedModule } from "../freightconfirmation/app.sharemodule";
import { NewDetailCardComponent } from './components/new-detail-card/new-detail-card.component';
import { NewcustomerHeaderComponent } from './components/newcustomer-header/newcustomer-header.component';
import { RechargeformComponent } from "../wallet/rechargeform/rechargeform.component";
// import { MessageService } from "primeng/api";
// import { ToastModule } from 'primeng/toast';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const componentList = [
  PageHeaderComponent,
  TableComponent,
  InputSearchBoxComponent,
  DetailsCardComponent,
  DriverLicenceFormComponent,
  DropdownFieldBoxComponent,
  FileUploadBoxComponent,
  InputDateTimeFieldBoxComponent,
  MapDetailsCardComponent,
  PaginationCustomComponent,
  RegistrationDocsFormComponent,
  ToggleSwitchBoxComponent,
  ViewEditUserImageBoxComponent,
  FilterBoxComponent,
  AddressDetailsFormComponent,
  ContentViewModalComponent,
  NewDefaultPageComponent,
  MainHeaderComponent,
  MainFooterComponent,
  EmptyPageComponent,
  TablePattern1Component,
  AttachmentListComponent,
  ConfirmationPopupComponent,
  ConfirmationPopup_warningComponent,
  ToastComponent,
  MenuListComponent,
  TripmapComponent,
  NewDetailCardComponent,
  NewcustomerHeaderComponent,
  // RechargeformComponent,
  // NumberFormatPipe
];
@NgModule({
  declarations: [componentList, UppercaseNumberPipe, TripmapComponent, NumberFormatPipe],
  exports: [componentList],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    TabViewModule,
    CalendarModule,
    NgbTypeaheadModule,
    ReactiveFormsModule,
    SplitButtonModule,
    SidebarModule,
    MenuModule,
    TooltipModule,
    NgbDropdownModule,
    AccordionModule,
    AutoCompleteModule,
    PanelMenuModule,
    NgSelectModule,
    OverlayPanelModule,
    // ToastModule,
    NgbModule.forRoot(),
    InputSwitchModule,
    CheckboxModule,
    RadioButtonModule,
    PaginationModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SharedModule
  ],
  providers: [
    DriverService,
    CommonService,
    EntityService,
    TranslateConfigService,
    // MessageService,
    MastersService,
    ToastComponent,
    ChartOfAccountsService,
    OrdersService,
  ],
  entryComponents: [ConfirmationPopupComponent, ConfirmationPopup_warningComponent],
})
export class SharedComponentModule { }
